import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryItem } from '../../../domain/dictionary.model';

@Pipe({
    name: 'flexFilter'
})
export class FlexFilterPipe implements PipeTransform {
    transform(list: DictionaryItem[], filter: string): DictionaryItem[] {
        return (list || []).filter(element => (element.flexFilter1 || []).indexOf(filter) !== -1);
    }
}
